import BaseSearchInput from "./BaseSearchInput.vue";

export default BaseSearchInput;
